<template>
    <div class="flex flex-column mb-2 mr-6">
        <div class="flex flex-row align-items-center mb-2">
            <div>{{ title }}</div>
            <div class="ml-2 text-gray-500 cursor-pointer">
                <i class="pi pi-question-circle"
                   v-tooltip.bottom="description"></i></div>
        </div>
        <div class="flex flex-row align-items-center">
            <InputText type="text" v-model="innerValue" class="w-4rem p-1 mb-1" />
            <div v-if="show_controls" class="ml-1 px-1 mr-1 cursor-pointer" @click="decrement"><i class="pi pi-minus text-sm"></i></div>
            <div v-if="show_controls" class="px-1 mr-1 cursor-pointer" @click="increment"><i class="pi pi-plus text-sm"></i></div>
        </div>

    </div>
</template>

<script>
import InputText from "primevue/inputtext";
import helpers from "@/helpers";
export default{
    components: {InputText},
    props:{
        title: String,
        description: String,
        value: [String, Number],
        step: String,
        min: String,
        max: String,
        show_controls: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return {
            innerValue: this.value
        }
    },
    watch:{
        value: {
            handler(val){
                this.innerValue = val;
            },
            immediate: true
        },
        innerValue: {
            handler(val){
                this.$emit('input', val);
            }
        }
    },
    methods: {
        increment() {
            let step = this.step || 1;
            let newValue = this.innerValue*1 + step*1; // *1 to convert to number (btw i hate js)
            newValue = this.round(newValue, this.precision(step));
            if (this.max && newValue > this.max) {
                newValue = this.max;
            }
            this.$emit('input', newValue);
        },
        decrement() {
            let step = this.step || 1;
            let newValue = this.innerValue - step;
            newValue = this.round(newValue, this.precision(step));
            if (this.min && newValue < this.min) {
                newValue = this.min;
            }
            this.$emit('input', newValue);
        },
        precision(step){
            if(step.toString().includes(".") && step.toString().split(".")[1].length > 0){
                return step.toString().split(".")[1].length;
            }
            return 0;
        },
        ...helpers
    }
}
</script>
